import { Components, SlideComponent, Splide } from '@splidejs/splide'
import filter from 'lodash/filter'
import first from 'lodash/first'
import some from 'lodash/some'
import { css, keyframes } from 'styled-components'

const bounceAnimation = (direction: string) => keyframes`
  0% {
    transform: translateX(0px)
  }
  50% {
    transform: translateX(${direction === 'left' ? '120px' : '-120px'})
  }
  100% {
    transform: translateX(0px)
  }
`

export const bounceExtensionCSS = css`
  .splide__slide_bounce {
    animation-duration: 0.3s;
    animation-iteration-count: 1;

    &-left {
      animation-name: ${bounceAnimation('left')};
    }

    &-right {
      animation-name: ${bounceAnimation('right')};
    }
  }
`

// Purpose of this extention is to handle bounce effect
export const BounceExtension = (splide: Splide, components: Components) => {
  const prev = first(splide.root.getElementsByClassName('splide__arrow--prev')) as HTMLButtonElement | undefined
  const next = first(splide.root.getElementsByClassName('splide__arrow--next')) as HTMLButtonElement | undefined

  const onClick = ({ currentTarget }: MouseEvent) => {
    const direction = (currentTarget as HTMLButtonElement).dataset?.direction ?? 'right'
    const slidesVisible = components.Slides.filter(s => s.slide.classList.contains('is-visible'))

    const visibleCount = slidesVisible.length
    const directionIsRight = direction === 'right'
    const nextVisible = filter(components.Slides, (s, i: number) => {
      const nextCount = directionIsRight ? (i - visibleCount) : (i + visibleCount)
      const slide = components.Slides.getAt(nextCount)
      return slide?.slide.classList.contains('is-visible')
    })

    const nextHittingEnd = () => some([...nextVisible, ...slidesVisible], (a: SlideComponent) => a.index === components.Slides.getLength() - 1)
    const nextHittingStart = () => some([...nextVisible, ...slidesVisible], (a: SlideComponent) => a.index === 0)

    const hittingEnd: boolean = directionIsRight && (nextHittingEnd())
    const hittingStart: boolean = !directionIsRight && (nextHittingStart())

    if (hittingEnd || hittingStart) {
      components.Slides.forEach((slide) => {
        slide?.slide.classList.add('splide__slide_bounce')
        slide?.slide.classList.add(`splide__slide_bounce-${direction}`)
      })
      setTimeout(() => {
        components.Slides.forEach((slide) => {
          slide?.slide.classList.remove('splide__slide_bounce')
          slide?.slide.classList.remove(`splide__slide_bounce-${direction}`)
        })
      }, 300)
    }
  }

  const bounceMount = () => {
    if (prev?.disabled) {
      prev?.removeAttribute('disabled')
      prev.dataset.direction = 'left'
    }
    if (next?.disabled) {
      next?.removeAttribute('disabled')
      next.dataset.direction = 'right'
    }
  }

  const mount = () => {
    next?.addEventListener('click', onClick)
    prev?.addEventListener('click', onClick)
    splide.on('arrows:updated.bounce', bounceMount)
    bounceMount()
  }

  const destroy = () => {
    splide.off('arrows:updated.bounce')
  }

  return {
    destroy,
    mount,
  }
}
